import { State } from '../../../store/reducers';

export const getCurrentPage = (state: State) => state?.catalog?.currentPage;

export const getCurrentSortMode = (state: State) => state?.catalog?.currentSortMode;
